export default "__VITE_ASSET__fbdc3675__"